"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-this-alias, @typescript-eslint/explicit-function-return-type  */
var events_1 = require("events");
//! this might not work correctly because of this??
function throttle(func, limit) {
    var _this = this;
    var inThrottle;
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var context = _this;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(function () {
                inThrottle = false;
            }, limit);
        }
    };
}
var IdleTimer = /** @class */ (function (_super) {
    __extends(IdleTimer, _super);
    function IdleTimer(options) {
        var _this = _super.call(this) || this;
        _this.handleEvent = function () {
            if (_this.idleStart) {
                _this.totalIdleTime += Date.now() - _this.idleStart;
            }
            _this.reset();
            _this.emit('active');
            _this.start();
        };
        _this.options = __assign({ timeout: 5000, throttle: 500, events: [
                'mousemove',
                'mousedown',
                'mousewheel',
                'wheel',
                'keydown',
                'touchstart',
                'touchmove',
                'scroll',
                // 'onclick',
                'DOMMouseScroll'
            ] }, options);
        _this.totalIdleTime = 0;
        _this.idleStart = null;
        _this.event = throttle(_this.handleEvent, _this.options.throttle || 0);
        _this.attachEvents();
        return _this;
    }
    Object.defineProperty(IdleTimer.prototype, "idleTime", {
        get: function () {
            return this.totalIdleTime;
        },
        enumerable: false,
        configurable: true
    });
    IdleTimer.prototype.attachEvents = function () {
        var _this = this;
        if (this.options.events)
            this.options.events.forEach(function (event) {
                window.addEventListener(event, _this.event, { passive: true });
            });
    };
    IdleTimer.prototype.removeEvents = function (events) {
        var _this = this;
        if (events === void 0) { events = this.options.events; }
        if (events)
            events.forEach(function (event) {
                window.removeEventListener(event, _this.event, { passive: true });
            });
    };
    IdleTimer.prototype.start = function () {
        var _this = this;
        if (this.timer)
            return;
        this.timer = setTimeout(function () {
            _this.emit('idle');
            _this.idleStart = Date.now();
        }, this.options.timeout);
        this.emit('start');
    };
    IdleTimer.prototype.reset = function () {
        clearTimeout(this.timer);
        this.timer = null;
        this.idleStart = null;
    };
    IdleTimer.prototype.stop = function () {
        this.reset();
        this.removeEvents();
        this.emit('stop');
    };
    return IdleTimer;
}(events_1.EventEmitter));
exports.default = IdleTimer;
// if you want to what the timer is doing, you can add the following events wherever you declared timer:
// this.timer.on('start', () => {
//   console.warn(
//     `[${this.componentName}] timer started`
//   );
// });
// this.timer.on('stop', () => {
//   console.warn(
//     `[${this.componentName}] timer stopped`
//   );
// });
// this.timer.on('idle', () => {
//   console.warn(
//     `[${
//       this.componentName
//     }] user became idle`
//   );
// });
// this.timer.on('active', () => {
//   console.warn(
//     `[${
//       this.componentName
//     }] user became active`
//   );
// });
